import { useState } from 'react';

/**
 * @deprecated
 * @param initialValue
 */
const useToggle = (initialValue?: boolean) => {
  const [value, setValue] = useState(!!initialValue);

  const toggle = () => setValue((prev) => !prev);

  return [value, setValue, toggle] as const;
};

export { useToggle };
